var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EAF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 11.667h7.693v7.692h-7.693v-7.692zM11.666 20.641h7.693v7.692h-7.693v-7.692zM20.64 11.667h7.693v7.692h-7.692v-7.692zM20.64 20.641h7.693v7.692h-7.692v-7.692z",
    fill: "#339BFE"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFQUY1RkYiLz4KPHBhdGggZD0iTTExLjY2NjUgMTEuNjY2N0gxOS4zNTg4VjE5LjM1OUgxMS42NjY1VjExLjY2NjdaIiBmaWxsPSIjMzM5QkZFIi8+CjxwYXRoIGQ9Ik0xMS42NjY1IDIwLjY0MUgxOS4zNTg4VjI4LjMzMzRIMTEuNjY2NVYyMC42NDFaIiBmaWxsPSIjMzM5QkZFIi8+CjxwYXRoIGQ9Ik0yMC42NDA5IDExLjY2NjdIMjguMzMzMlYxOS4zNTlIMjAuNjQwOVYxMS42NjY3WiIgZmlsbD0iIzMzOUJGRSIvPgo8cGF0aCBkPSJNMjAuNjQwOSAyMC42NDFIMjguMzMzMlYyOC4zMzM0SDIwLjY0MDlWMjAuNjQxWiIgZmlsbD0iIzMzOUJGRSIvPgo8L3N2Zz4K";
export { SvgWindows as ReactComponent };